import { render, staticRenderFns } from "./UpgradePreview.vue?vue&type=template&id=2f9fa638"
import script from "./UpgradePreview.vue?vue&type=script&lang=js"
export * from "./UpgradePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports